import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../-LazyRoutePage"

const KSeFInvoiceDetailPage = lazy(
  () => import("../../../../components/WMS/KSeF/KSeFInvoiceDetailPage.tsx"),
)

export const Route = createFileRoute("/_layout/WMS/ksef/$invoiceId")({
  component: KSeFInvoiceDetailRoute,
})

function KSeFInvoiceDetailRoute() {
  return (
    <LazyRoutePage>
      <KSeFInvoiceDetailPage />
    </LazyRoutePage>
  )
}
